var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',[_c('b-card',[_c('template',{slot:"header"},[_vm._v("\n                            Welkom "+_vm._s(_vm.userName)+"!\n                        ")])],2)],1)],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }